export default {
  computed: {
    certifications() {
      let certifications = []

      if (this.applicator.badges.includes('cerakote_robotics')) {
        certifications.push('Robotics')
      }

      if (this.applicator.badges.includes('cerakote_distributor')) {
        certifications.push('Distributor')
      }

      if (this.applicator.badges.includes('cerakote_high_volume')) {
        certifications.push('HighVolume')
      }

      if (this.applicator.badges.includes('cerakote_laser_certified')) {
        certifications.push('Laser Imaging Certified')
      }

      return certifications
    },

    pageURL() {
      return `/applicators/${this.applicator.user_id}/${this.URLSlugify(this.applicator.company_name)}`
    },

    hasShowcaseProjects() {
      return this.applicator.top_project_picture_urls?.length > 0
    },

    hasBannerImage() {
      return this.applicator.banner_picture_url?.length > 0
    },

    isCustomersChoice() {
      return this.$attrs.customerchoice || this.applicator.is_customer_choice
    },

    isOnMap() {
      return this.applicator.badges.includes('on_map_cerakote')
    },

    isComingSoon() {
      return this.applicator.badges.includes('coming_soon_cerakote')
    },

    isLaserCertified() {
      return this.applicator.badges.includes('cerakote_laser_certified') ?? false
    },

    isDistributor() {
      return (this.applicator.badges.includes('distributor') || this.applicator.badges.includes('cerakote_distributor')) ?? false
    },

    isCertified() {
      return (this.isOnMap && (this.applicator.badges.includes('certified') || this.isDistributor)) ?? false
    },

    hasAboutUs() {
      return this.applicator.about?.length > 0
    },

    hasBusinessHours() {
      return this.applicator.business_hours?.length > 0
    },

    hasWebsite() {
      return this.applicator.website?.length > 0
    },

    hasFacebook() {
      return this.applicator.facebook_url?.length > 0
    },

    hasInstagram() {
      return this.applicator.instagram_url?.length > 0
    },

    hasTwitter() {
      return this.applicator.twitter?.length > 0
    },

    hasSocialMedia() {
      return this.hasFacebook || this.hasInstagram || this.hasTwitter
    },

    profileURL() {
      return `/applicators/${this.applicator.user_id}/${this.URLSlugify(this.applicator.company_name)}`
    },

    workAcceptedPreview() {
      if (this.applicator.work_accepted !== null) {
        return this.applicator.work_accepted.length > 0 ? this.applicator.work_accepted.slice(0, 3) : []
      } else {
        return []
      }
    },

    certificationsPreview() {
      return this.certifications.length > 0 ? this.certifications.slice(0, 3) : []
    },

    label() {
      const labels = []

      if (this.isCustomersChoice) {
        labels.push({
          name: 'Customers Choice',
          class: 'customers-choice',
          icon: 'trophy',
        })
      }

      if (this.isDistributor) {
        labels.push({
          name: 'Distributor',
          class: 'distributor',
          icon: 'truck',
        })
      }

      // Prioritize Certified over Coming Soon
      if (this.isCertified) {
        labels.push({
          name: 'Certified',
          class: 'certified',
          icon: 'check-square',
        })
      } else if (this.isComingSoon) {
        labels.push({
          name: 'Coming Soon',
          class: 'comingSoon',
          icon: 'clock-o',
        })
      }

      if (this.isLaserCertified) {
        labels.push({
          name: 'Laser Imaging Certified',
          class: 'certified',
          icon: 'check-square',
        })
      }

      return labels.length > 0 ? labels : false
    },
  },
}
